import { useState } from "react";
import {
    AppBar,
    Toolbar,
    Typography,
    IconButton,
    Drawer, FormControl, InputLabel, Select, MenuItem,
    Box, Menu,
    List,
    ListItem,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    Container, useMediaQuery,
    Chip,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import * as MuiIcons from "@mui/icons-material";
import MenuIcon from "@mui/icons-material/Menu";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import { useNavigate, Outlet, useLocation } from "react-router-dom";
import LogoutIcon from "@mui/icons-material/Logout";
import { useData } from '../../context/DataContext';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { getClientTheme } from "../../theme/clientTheme";


import NavakranthiLogo from '../../assets/navakranthi-logo.png';
import KesahavapurLogo from '../../assets/keshavapurLogo.jpeg';


const DrawerHeader = styled("div")(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: theme.spacing(0, 2),
    ...theme.mixins.toolbar,
    position: "relative",
}));

const Layout = styled(Box)({
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
});


const NavBar = () => {
    const { user = {}, handleClientIdChange, user_client_id, handleLogout } = useData();
    const clientTheme = getClientTheme(user_client_id);
     
    const [open, setOpen] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const isMobile = useMediaQuery("(max-width:600px)");
    const [anchorEl, setAnchorEl] = useState(null);

    const handleMenuOpen = e => setAnchorEl(e.currentTarget);
    const handleMenuClose = () => setAnchorEl(null);

    const navLinks = [
        { id: 1, path: "/dashboard", name: "Dashboard", icon: "Dashboard" },
        { id: 2, path: "/training/history", name: "Training Plans", icon: "School" },
        { id: 3, path: "/trainingSession/history", name: "Training Session", icon: "Event" },
        { id: 4, path: "/soilReport/history", name: "Soil Report", icon: "Description" },
        { id: 5, path: "/field_book/history", name: "Field Book", icon: "MenuBook" },
        { id: 6, path: "/adOption/history", name: "Adoption", icon: "Groups" },
        // ...(user?.user_level_id === 1 || user?.user_level_id === 2
        //     ? [{ id: 7, path: "/employee/history", name: "Employees", icon: "People", },] : [])
    ];

    const toggleDrawer = (status) => () => setOpen(status);

    const handleNavigate = (path) => {
        navigate(path);
        setOpen(false);
    };

    const activeItem = navLinks.find(item => item.path === location.pathname);

    const titleStyles = {
        flexGrow: 1,
        fontWeight: 600,
        ml: 1,
        textTransform: "uppercase",
        display: "flex",
        alignItems: "center",
        gap: 1
    };

    const logoName = +user_client_id === 1 ? "Navakranthi" : "Keshavapur";

    return (
        <Layout>
            <AppBar
                position="fixed"
                sx={{
                    color: "#fff",
                    backgroundColor: clientTheme.activeBg,
                    boxShadow: "0px 3px 10px rgba(0,0,0,0.3)",
                    height: 58,
                }}
            >
                <Toolbar>
                    {/* Drawer Button */}
                    <IconButton color="inherit" onClick={toggleDrawer(true)}>
                        <MenuIcon />
                    </IconButton>

                    {/* Title / Logo */}
                    <Typography variant="h6" sx={{ flexGrow: 1 }}>
                        <Typography variant="h6" sx={titleStyles}>
                            {activeItem ? (
                                <>
                                    {(() => {
                                        const Icon = MuiIcons[activeItem.icon] || MuiIcons.HelpOutline;
                                        return (
                                            <Icon
                                                sx={{
                                                    fontSize: "28px",
                                                    color: clientTheme.iconColor,
                                                }}
                                            />
                                        );
                                    })()}
                                    {activeItem.name}
                                </>
                            ) : (
                                <Box
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 1,
                                        color: clientTheme.activeTextColor,
                                        backgroundColor: clientTheme.activeBg,
                                        p: 0.8,
                                        borderRadius: 3
                                    }}
                                >
                                    {/* Logo Image */}
                                    <Box
                                        component="img"
                                        src={+user_client_id === 1 ? NavakranthiLogo : KesahavapurLogo}
                                        sx={{
                                            height: 30,
                                            objectFit: "contain"
                                        }}
                                    />

                                    {/* Logo Name Text */}
                                    <Typography
                                        sx={{
                                            fontWeight: 700,
                                            fontSize: "1rem",
                                            color: clientTheme.activeTextColor,
                                        }}
                                    >
                                        {logoName}
                                    </Typography>
                                </Box>
                            )}
                        </Typography>
                    </Typography>

                    {
                        user?.user_level_id === 1 || user?.user_level_id === 2 ? (
                            <>
                                {/* ---------- Desktop (Select) ---------- */}
                                {!isMobile && (
                                    <FormControl sx={{ m: 1, minWidth: 150 }} size="small">
                                        <InputLabel sx={{ color: clientTheme.activeTextColor, }}>Select Client</InputLabel>
                                        <Select
                                            value={user_client_id}
                                            label="Select Client"
                                            onChange={e => handleClientIdChange(e.target.value)}
                                            MenuProps={{
                                                PaperProps: { sx: { zIndex: 2000 } },
                                                disableScrollLock: true
                                            }}
                                            sx={{
                                                color: clientTheme.activeTextColor,
                                                ".MuiOutlinedInput-notchedOutline": { color: clientTheme.activeTextColor, },
                                                "&:hover .MuiOutlinedInput-notchedOutline": { color: clientTheme.activeTextColor, },
                                                "&.Mui-focused .MuiOutlinedInput-notchedOutline": { color: clientTheme.activeTextColor, },
                                                ".MuiSvgIcon-root": { color: clientTheme.activeTextColor, }
                                            }}
                                        >
                                            <MenuItem value={1}>Navakranthi</MenuItem>
                                            <MenuItem value={2}>keshavapur</MenuItem>
                                        </Select>
                                    </FormControl>
                                )}

                                {/* ---------- Mobile (Icon Menu) ---------- */}
                                {isMobile && (
                                    <>
                                        <IconButton color="inherit" onClick={handleMenuOpen}>
                                            <AccountCircleIcon />
                                        </IconButton>

                                        <Menu
                                            anchorEl={anchorEl}
                                            open={Boolean(anchorEl)}
                                            onClose={handleMenuClose}
                                        >
                                            <MenuItem onClick={() => { handleClientIdChange(1); handleMenuClose(); }}>
                                                Navakranthi
                                            </MenuItem>

                                            <MenuItem onClick={() => { handleClientIdChange(2); handleMenuClose(); }}>
                                                keshavapur
                                            </MenuItem>
                                        </Menu>

                                    </>
                                )}
                            </>
                        ) : (
                            <Box>
                                <Chip
                                    label={user?.name ?? "-"}
                                    size="medium"
                                    variant="outlined"
                                    sx={{
                                        color: clientTheme.activeTextColor,     // text color
                                        borderColor: clientTheme.activeTextColor    // border color
                                    }}
                                />
                            </Box>
                        )
                    }
                </Toolbar>
            </AppBar>

            {/* Drawer Sidebar */}
            <Drawer
                anchor="left"
                open={open}
                onClose={toggleDrawer(false)}
                PaperProps={{
                    sx: {
                        width: 260,
                        display: "flex",
                        flexDirection: "column",
                        backgroundColor: clientTheme.sidebarBg,
                    },
                }}
            >
                {/* Header */}
                <DrawerHeader
                    sx={{
                        background: "#fff",
                        minHeight: isMobile ? 80 : 120,
                        display: "grid",
                        alignItems: "center",
                        borderBottom: "1px solid rgba(0,0,0,0.15)",
                        position: "relative"
                    }}
                >
                    <IconButton
                        onClick={toggleDrawer(false)}
                        aria-label="close drawer"
                        sx={{
                            position: "absolute",
                            right: 8,
                            top: isMobile ? 20 : 8,
                            color: clientTheme.activeTextColor,
                            backgroundColor: clientTheme.activeBg,
                            "&:hover": {
                                backgroundColor: clientTheme.hoverBg
                            }
                        }}
                    >
                        <ChevronLeftIcon />
                    </IconButton>

                    <Box
                        sx={{
                            width: "80%",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                        }}
                    >

                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 1,
                                background: "#fff",
                                p: 0.8,
                                borderRadius: 3
                            }}
                        >
                            {/* Logo Image */}
                            <Box
                                component="img"
                                src={+user?.client_id === 1 ? NavakranthiLogo : KesahavapurLogo}
                                sx={{
                                    height: 30,
                                    objectFit: "contain"
                                }}
                            />

                            {/* Logo Name Text */}
                            <Typography
                                sx={{
                                    fontWeight: 700,
                                    fontSize: "1rem",
                                    color: clientTheme.headerText
                                }}
                            >
                                {logoName}
                            </Typography>
                        </Box>
                    </Box>
                </DrawerHeader>


                {/* Navigation */}
                <List>
                    {navLinks.map(({ id, path, name, icon }) => {
                        const Icon = MuiIcons[icon] || MuiIcons.HelpOutline;
                        const isSelected = location.pathname.startsWith(path);

                        return (
                            <ListItem key={id} disablePadding>
                                <ListItemButton
                                    selected={isSelected}
                                    onClick={() => handleNavigate(path)}

                                    sx={{
                                        color: clientTheme.textColor,
                                        py: 1.2,
                                        mx: 1,
                                        my: 0.5,
                                        borderRadius: "10px",

                                        "&.Mui-selected": {
                                            backgroundColor: clientTheme.activeBg,
                                            color: clientTheme.activeTextColor,
                                            boxShadow: `inset 4px 0 0 ${clientTheme.activeBorder}`,
                                        },

                                        "&.Mui-selected:hover": {
                                            backgroundColor: clientTheme.activeBg,
                                        },

                                        "&:hover": {
                                            backgroundColor: clientTheme.hoverBg,
                                            color: clientTheme.activeTextColor,
                                            boxShadow: `inset 4px 0 0 ${clientTheme.activeBorder}`,
                                        },
                                    }}
                                >
                                    <ListItemIcon
                                        sx={{
                                            color: isSelected
                                                ? clientTheme.activeTextColor
                                                : clientTheme.iconColor,
                                            minWidth: 40,
                                        }}
                                    >
                                        <Icon />
                                    </ListItemIcon>

                                    <ListItemText
                                        primary={name}
                                        sx={{
                                            "& span": {
                                                fontWeight: isSelected ? 600 : 400,
                                                fontSize: "0.95rem",
                                            },
                                        }}
                                    />
                                </ListItemButton>
                            </ListItem>
                        );
                    })}
                </List>


                {/* Logout at Bottom */}
                <Box sx={{ mt: "auto", p: 1.5 }}>
                    <ListItem disablePadding>
                        <ListItemButton
                            onClick={handleLogout}
                            sx={{
                                borderRadius: "10px",
                                color: clientTheme.activeTextColor,
                                backgroundColor: "rgba(255,255,255,0.1)",
                                "&:hover": {
                                    backgroundColor: "rgba(239,68,68,0.25)",
                                    color: clientTheme.activeTextColor,
                                },
                            }}
                        >
                            <ListItemIcon sx={{ color: clientTheme.activeTextColor, minWidth: 40 }}>
                                <LogoutIcon />
                            </ListItemIcon>
                            <ListItemText
                                primary="Logout"
                                sx={{ "& span": { fontWeight: 500 } }}
                            />
                        </ListItemButton>
                    </ListItem>
                </Box>
            </Drawer>

            {/* Main Content */}
            <Container maxWidth="xl">
                <Box mt={10} mb={5}>
                    <Outlet />
                </Box>
            </Container>
        </Layout >
    );
};
export default NavBar;